module.exports = __webpack_public_path__ + "img/Produtos02.fw.f26cb00e.png";